import { createTheme } from '@mui/material/styles';
import { defaultPalette } from './palette/default';
import { typography } from './typography';

// A custom theme for this app
const theme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        // Name of the rule
        // Some CSS
        root: {
          color: '#43425d',
        },
      },
    },
  },
  palette: defaultPalette,
  typography,
});

export default theme;
